import { render, staticRenderFns } from "./LandscapePage.vue?vue&type=template&id=3a09a320&scoped=true"
var script = {}
import style0 from "./LandscapePage.vue?vue&type=style&index=0&id=3a09a320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a09a320",
  null
  
)

export default component.exports